var __WEBPACK_NAMESPACE_OBJECT__ = require("@onfido/active-video-capture");